import { render, staticRenderFns } from "./shopbuy_message.vue?vue&type=template&id=2df07498&scoped=true&"
import script from "./shopbuy_message.vue?vue&type=script&lang=js&"
export * from "./shopbuy_message.vue?vue&type=script&lang=js&"
import style0 from "./shopbuy_message.vue?vue&type=style&index=0&lang=css&"
import style1 from "./shopbuy_message.vue?vue&type=style&index=1&id=2df07498&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df07498",
  null
  
)

export default component.exports